import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../redux-store/store";
import { IconButton, Badge } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import InfoIcon from "@mui/icons-material/Info";
import { Button  } from "@material-ui/core";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { useTranslation, withTranslation } from "react-i18next";
import UserInfo from "../UserInfo";
import noImg from "../../assets/images/no-image.svg";

import"./HomeBanner.scss";
const HomeBannerLavazza = ({ branchIsLoading }) => {
  const {t} = useTranslation();
  const appState = useSelector((state) => state);
  const dispatch = useDispatch();
  const { setLangValue } = bindActionCreators(actionCreators, dispatch);

  const [scroll, setScroll] = useState(false);
  const matches = useMediaQuery("(min-width:600px)");

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const changeLang = (lang) => setLangValue(lang);

  const handleLogin = () => {
    dispatch({ type: "setLoginModal", loginModal: true });
  };

  const renderLangButtons = () => (
    <>
      <IconButton id="headerBtn" onClick={() => changeLang(appState.langValue === "ar" ? "en" : "ar")}>
        <span className={`lang-text ${scroll ? "lang-textScroll" : ""}`}>
          {appState.langValue === "ar" ? "EN" : "عربي"}
        </span>
      </IconButton>

      {appState.storeInfo?.chinessLanguage && (
        <IconButton id="headerBtn" onClick={() => changeLang(appState.langValue === "ch" ? "en" : "ch")}>
          <span className={`lang-text ${scroll ? "lang-textScroll" : ""}`}>
            {appState.langValue === "ch" ? "EN" : "CH"}
          </span>
        </IconButton>
      )}
    </>
  );

  const renderSearchIcon = () => (
    <IconButton component={Link} to="/search" className="classForSvgColor" id="headerBtn">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill="#fff"
          d="M11 2.25C6.17 2.25 2.25 6.17 2.25 11s3.92 8.75 8.75 8.75c2.15 0 4.11-.77 5.63-2.06l2.84 2.84a.75.75 0 001.06-1.06l-2.84-2.84A8.71 8.71 0 0019.75 11C19.75 6.17 15.83 2.25 11 2.25zM3.75 11a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z"
        />
      </svg>
    </IconButton>
  );

  return (
    <div id="home-banner-lavazza" className="storeBanner">
      <img
        src={
          appState.storeInfo.cover && !branchIsLoading
            ? appState.storeInfo.cover
            : noImg
        }
        alt="store-banner"
      />

        <div className="row m-0 justify-content-end align-items-end  store-info ">
          <Link  to="/contact"  className={`p-0 m-0 ${    appState.storeInfo.disabledBtns ? `pe-none` : ``  }   `} >
            <Button
              variant="outlined"
              className={`infoBtn ${
                appState.storeInfo.disabledBtns ? `pe-none` : ``
              }`}
              startIcon={<InfoIcon />}
            >
              <span className={appState.langValue === "ar" ? "mx-1" : ""}>
                {" "}
                {t("contact.info")}
              </span>
            </Button>
           </Link>
        </div>
        
      <div className={`top_nav_bar ${scroll ? "top_nav_bar_scroll" : ""}`}>
        <div className="row m-0 searhIcon">
          <div className=" d-flex align-items-center px-1 col-4" style={{zIndex: 1000}}>
            {renderLangButtons()}
            {renderSearchIcon()}
            {appState.showTagsAndDitesFilter &&
              (appState.tags.length > 0 || appState.dietaries.length > 0) && (
                <IconButton onClick={() => dispatch({   type: "setFilterProductMode",   filterProductMode: true })} component={Link} to="/" id="headerBtn" >
                  <FilterListIcon fontSize="inherit" />
                </IconButton>
              )}

                {(appState.formData.openBill && appState.qrBranch &&appState.openBill &&!appState.hotelQrCode &&!appState.payTableMode) ? (
                  <IconButton component={Link} className="classForSvgColor mb-1" to="/openOrder" id="headerBtn"  style={{zIndex: 1000}}>
                        <span>
                          <div className="ring-container-open-bill">
                            <div className="ringring"></div>
                            <div className="circle"></div>
                          </div>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M4.25 7C4.25 6.58579 4.58579 6.25 5 6.25H9C9.41421 6.25 9.75 6.58579 9.75 7C9.75 7.41421 9.41421 7.75 9 7.75H5C4.58579 7.75 4.25 7.41421 4.25 7Z" fill="#fff" />
                            <path d="M5 10.25C4.58579 10.25 4.25 10.5858 4.25 11C4.25 11.4142 4.58579 11.75 5 11.75H11C11.4142 11.75 11.75 11.4142 11.75 11C11.75 10.5858 11.4142 10.25 11 10.25H5Z" fill="#fff" />
                            <path d="M4.25 15C4.25 14.5858 4.58579 14.25 5 14.25H11C11.4142 14.25 11.75 14.5858 11.75 15C11.75 15.4142 11.4142 15.75 11 15.75H5C4.58579 15.75 4.25 15.4142 4.25 15Z" fill="#fff" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M0.623556 0.351317C0.854792 0.217126 1.13998 0.216174 1.37211 0.348818L4.5 2.13619L7.6279 0.348818C7.85847 0.217061 8.14153 0.217061 8.37211 0.348818L11.5 2.13619L14.6279 0.348818C14.86 0.216174 15.1452 0.217126 15.3764 0.351317C15.6077 0.485509 15.75 0.732647 15.75 1V9.25H19C19.4142 9.25 19.75 9.58579 19.75 10V17C19.75 18.5188 18.5188 19.75 17 19.75H6.94513C5.57754 19.75 4.47522 19.75 3.60825 19.6335C2.70814 19.5125 1.95027 19.2536 1.34835 18.6517C0.746434 18.0497 0.48754 17.2919 0.366524 16.3918C0.249963 15.5248 0.24998 14.4225 0.250001 13.0549V1C0.250001 0.732647 0.39232 0.485509 0.623556 0.351317ZM17 18.25C17.6904 18.25 18.25 17.6904 18.25 17V10.75H15.75V17C15.75 17.6904 16.3096 18.25 17 18.25ZM14.5499 18.25H7C5.56459 18.25 4.56347 18.2484 3.80812 18.1469C3.07435 18.0482 2.68577 17.8678 2.40901 17.591C2.13225 17.3142 1.9518 16.9257 1.85315 16.1919C1.75159 15.4365 1.75 14.4354 1.75 13V2.29238L4.1279 3.65118C4.35847 3.78294 4.64153 3.78294 4.87211 3.65118L8 1.86381L11.1279 3.65118C11.3585 3.78294 11.6415 3.78294 11.8721 3.65118L14.25 2.29239V17C14.25 17.4501 14.3581 17.875 14.5499 18.25Z" fill="#fff" />
                          </svg>
                        </span>
                  </IconButton>  )
                  : ( "" )}


                {!appState.payTableMode && appState.qrBranch && (
                              <IconButton
                                className="classForSvgColor"
                                component={Link}
                                to="/cart"
                                id="headerBtn"
                              >
                                {appState.cart.length !== 0 ? (
                                  <Badge
                                    badgeContent={appState.cart.length}
                                    color="primary"
                                    overlap="rectangular"
                                  >
                                    {/* <i className="fa fa-shopping-cart" ></i> */}
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M1.50007 2.75C1.78476 2.75001 1.88363 2.75062 1.96779 2.75751C2.81868 2.82715 3.55687 3.37236 3.87364 4.16516C3.90498 4.24358 3.93463 4.3379 4.01838 4.61008L5.99316 11.0281C6.29594 12.0122 6.54213 12.8124 6.81597 13.4359C7.10167 14.0864 7.44679 14.6169 7.98784 15.0165C8.52889 15.4161 9.13745 15.59 9.84321 15.6717C10.5197 15.7501 11.3569 15.7501 12.3865 15.7501H14.581C15.6178 15.7501 16.4607 15.7501 17.1414 15.6709C17.8515 15.5883 18.4635 15.4126 19.0064 15.0087C19.5493 14.6047 19.8934 14.069 20.1766 13.4126C20.4481 12.7834 20.6902 11.9761 20.9881 10.983L21.1909 10.3072C21.5299 9.17741 21.8081 8.2499 21.918 7.50536C22.0325 6.72982 21.9907 5.99351 21.5182 5.35851C21.0458 4.7235 20.3525 4.47191 19.5768 4.35869C18.8321 4.25001 17.8638 4.25003 16.6842 4.25006L5.5 4.25006C5.49234 4.25006 5.48471 4.25018 5.47711 4.25041L5.44241 4.13763C5.37194 3.90851 5.32359 3.7513 5.26657 3.60859C4.73861 2.28727 3.5083 1.37857 2.09014 1.26251C1.93697 1.24997 1.77251 1.24998 1.53278 1.25L1.50002 1.25L0.999908 1.25006C0.585695 1.25011 0.249949 1.58594 0.25 2.00016C0.250051 2.41437 0.585878 2.75011 1.00009 2.75006L1.50007 2.75ZM7.41361 10.544L5.93855 5.75006H16.6239C17.8788 5.75006 18.7367 5.75197 19.3602 5.84297C19.9654 5.93129 20.1875 6.08276 20.3148 6.2539C20.4421 6.42504 20.5234 6.68131 20.4341 7.28634C20.3421 7.90972 20.0974 8.7319 19.7368 9.93394L19.5644 10.5086C19.2504 11.5555 19.0322 12.2787 18.7993 12.8185C18.5742 13.3402 18.3653 13.616 18.111 13.8052C17.8567 13.9944 17.5325 14.1153 16.9681 14.1809C16.3841 14.2489 15.6287 14.2501 14.5358 14.2501H12.4314C11.346 14.2501 10.596 14.2489 10.0158 14.1817C9.45511 14.1167 9.13249 13.9972 8.87899 13.8099C8.6255 13.6227 8.41633 13.3495 8.18936 12.8327C7.95451 12.298 7.73281 11.5814 7.41361 10.544Z"
                                        fill="#fff"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.25 20C7.25 18.4812 8.48122 17.25 10 17.25C11.5188 17.25 12.75 18.4812 12.75 20C12.75 21.5188 11.5188 22.75 10 22.75C8.48122 22.75 7.25 21.5188 7.25 20ZM10 18.75C9.30964 18.75 8.75 19.3096 8.75 20C8.75 20.6904 9.30964 21.25 10 21.25C10.6904 21.25 11.25 20.6904 11.25 20C11.25 19.3096 10.6904 18.75 10 18.75Z"
                                        fill="#fff"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.25 20C15.25 18.4812 16.4812 17.25 18 17.25C19.5188 17.25 20.75 18.4812 20.75 20C20.75 21.5188 19.5188 22.75 18 22.75C16.4812 22.75 15.25 21.5188 15.25 20ZM18 18.75C17.3096 18.75 16.75 19.3096 16.75 20C16.75 20.6904 17.3096 21.25 18 21.25C18.6904 21.25 19.25 20.6904 19.25 20C19.25 19.3096 18.6904 18.75 18 18.75Z"
                                        fill="#fff"
                                      />
                                    </svg>
                                  </Badge>
                                ) : (
                                  ""
                                )}
                              </IconButton>
                            )}

          </div>

          <div className="d-flex justify-content-end col-8">
            {!appState.loggedIn ? (
              <IconButton
                className="signInBtn classForSvgColor"
                onClick={handleLogin}
                id="headerBtn"
              >
                <i className="fa fa-user text-white"></i>
              </IconButton>
            ) : (
              <UserInfo />
            )}

            {/* Add other dynamic buttons like openBill, shareBill, cart etc here */}
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default withTranslation()(HomeBannerLavazza);
